const ClickMenu = "Click Menu";
const ClickMenuAction = "Click_Menu_Action";

export default ClickMenu;
export { ClickMenu, ClickMenuAction };
